import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '../index'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

export const WORKSHOP_URL = `${POSITION_PROPERTY_URL}/workshops`

const errors = createHandbookResponseErrors('цех', 'цехов')

export const WorkshopApi = createNewHandbookApi(WORKSHOP_URL, errors)
